import { Buttons } from './Buttons';
import { Dates } from './Dates';
import { Details } from './Details';
import { Dropzone } from './Dropzone';
import { Errors } from './Errors';
import { Events } from './Events';
import { Forms } from './Forms';
import { Licenses } from './Licenses';
import { Lists } from './List';
import { Navigation } from './Navigation';
import { Objects } from './Objects';
import { Statistics } from './Statistics';
import { Toasts } from './Toasts';
import { Wizard } from './Wizard';

export const CommonMessage = {
    DATES: Dates,
    NAVIGATION: Navigation,
    OBJECTS: Objects,
    FORMS: Forms,
    BUTTONS: Buttons,
    EVENTS: Events,
    LISTS: Lists,
    DROPZONE: Dropzone,
    TOAST: Toasts,
    ERRORS: Errors,
    STATISTICS: Statistics,
    DETAIL: Details,
    LICENSES: Licenses,
    WIZARD: Wizard
};
